import { Component } from '@angular/core';

@Component({
  selector: 'requests-index-component',
  templateUrl: './index.component.html',
})
export class IndexComponent {}
